module.exports = __webpack_public_path__ + "img/appletv.54498ddc.png";